import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { DealsService } from 'src/app/services/deals.service';
import DateUtils from 'src/app/utils/date';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { ReportSettingsService } from 'src/app/settings/report-settings/report-settings.service';

@Component({
  selector: 'app-neglected-accounts',
  templateUrl: './neglected-accounts.component.html',
  styleUrls: ['./neglected-accounts.component.css']
})
export class NeglectedAccountsComponent implements OnInit {
  dateUtil = new DateUtils;
  dateRange = {startDate: null, endDate: null}
  lastActivityFilter = 10;
  dealsList;
  result;
  selectedIds = null;
  selectedType = null;
  unfiliterdResult: any[];
  dateType = '90';
  dataTable = {
    dataChangedObs: new BehaviorSubject(null),
    heads: [
      { title:  "Account Owner", key:  "source" },
      { title:  "Account Name", key:  "name" },
      { title:  "Days since last activity", key:  "lastActivityDuration" },
    ],
    rows: [],
    options: {
      debug: false, // change to true if you want to see datatable events
      noOfRowsToDisplay: 3, // change the amount of data you want to display at a particular time
      bulkActions: [],
      singleActions: [],
    }
  }
  constructor(
    private dealSrv: DealsService,
    private performRepSrv: PerformanceReportService,
    private reportSetSrv: ReportSettingsService,
  ) {
    this.dateRange = this.dateUtil.getDefReportDateRange(Number(this.dateType));
     this.performRepSrv.selected_users.subscribe(res => {
      if(res && res.type) {        
        const { ids, type } = res;
        this.selectedIds = ids;
        this.selectedType = type;
      } 
      this.getData()
    })
   }

  ngOnInit() {}
  dateChange({dateRange, dateType}) {
    this.dateRange = dateRange;
    this.dateType = dateType;
    this.getData();
  }
  getData() {
    let filter: any = {dateFilter: this.dateRange, status: 'OPEN'};
    this.result = null;
    if(this.selectedType === 'salesperson') {
      filter = {...filter, salesPerson: {ids: this.selectedIds}}
    }
    this.showLastActivity(filter)
  }
  showLastActivity(filter) {
    // this.lastActivity.loading = true
    const getRepCOnfig = this.reportSetSrv.getReportConfig();
    const getDealActivities = this.dealSrv.fetchDealsLastActivity(this.selectedIds, filter);
    forkJoin([getRepCOnfig, getDealActivities]).subscribe(([repConfig , dealActivities]) => {
      const configVal = repConfig ? repConfig.dealUnchangedDays : 2;
      if(dealActivities && dealActivities.length) {
        this.unfiliterdResult = dealActivities;
        this.handelFilterAct(configVal)
      } else {
        this.result = [];
        this.updateTable();
      }

    }).add(() => {})
  }
  getLastValue(obj: object) {
    let times = [];
    Object.values(obj).forEach((el, i) => {
      if (el < 0) return;
      times.push(el);
    });

    return times.reduce((latest, e) => {
      return e < latest ? e : latest;
    }, Number.MAX_SAFE_INTEGER);
  }
  handleDateFilter() {  
    this.getData();
  }
  handelFilterAct(configVal) {
    this.result = this.unfiliterdResult.filter(res => (res.lastActivityDuration !==0 && res.lastActivityDuration > configVal));
   this.updateTable()   
    if(this.lastActivityFilter || this.lastActivityFilter===0) {
    }
  }
  updateTable() {
    this.dataTable.rows = this.result;  
    this.dataTable.dataChangedObs.next(true);
  }

}
